"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = void 0;
var classes = {
  error: 'sec-mgr-date-picker-wrapper-error',
  errorLabel: 'sec-mgr-date-picker-wrapper-label',
  dateWrapper: 'sec-mgr-date-picker-wrapper'
};
exports.classes = classes;